import { defineComponent, ref, useSlots, computed, createElementBlock, openBlock, mergeProps, createVNode, withCtx, createCommentVNode, normalizeClass, renderSlot, createElementVNode, Fragment } from 'vue';
import _sfc_main$1 from './basler-components.es133.js';
import { useSlotContent } from './basler-components.es426.js';

const _hoisted_1 = {
  key: 1,
  class: "card__content-wrapper"
};
const _hoisted_2 = { class: "card__content" };
const _hoisted_3 = { class: "card__content" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Card",
  props: {
    hasLargeGutter: { type: Boolean, default: false },
    headerGutter: { type: Boolean, default: false },
    link: { default: void 0 },
    hasLinkBehavior: { type: Boolean, default: false },
    cardDataAttributes: {},
    horizontal: { type: Boolean, default: false }
  },
  setup(__props) {
    const props = __props;
    const footer = ref(null);
    const slots = useSlots();
    const { hasSlotContent } = useSlotContent();
    const hasHeaderSlotContent = computed(() => {
      return hasSlotContent(slots.header);
    });
    const hasFooterSlotContent = computed(() => {
      return hasSlotContent(slots.footer);
    });
    const cardDataAttributesWithPrefix = computed(() => {
      const cardDataAttributes = props.cardDataAttributes ?? {};
      const result = {};
      Object.keys(cardDataAttributes).forEach((key) => {
        result[`data-${key}`] = cardDataAttributes[key];
      });
      return result;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("article", mergeProps({
        class: [
          "card",
          { "card--large-gutter": _ctx.hasLargeGutter },
          { "card--has-link": _ctx.link || _ctx.hasLinkBehavior },
          { "card--horizontal": _ctx.horizontal }
        ]
      }, cardDataAttributesWithPrefix.value), [
        createVNode(_sfc_main$1, mergeProps(_ctx.link, { "is-renderless": true }), {
          default: withCtx(() => [
            hasHeaderSlotContent.value ? (openBlock(), createElementBlock("header", {
              key: 0,
              class: normalizeClass(["card__header", { "card__header--with-gutter": _ctx.headerGutter }])
            }, [
              renderSlot(_ctx.$slots, "header")
            ], 2)) : createCommentVNode("", true),
            _ctx.horizontal ? (openBlock(), createElementBlock("div", _hoisted_1, [
              createElementVNode("div", _hoisted_2, [
                renderSlot(_ctx.$slots, "default")
              ]),
              hasFooterSlotContent.value ? (openBlock(), createElementBlock("footer", {
                key: 0,
                ref_key: "footer",
                ref: footer,
                class: "card__footer"
              }, [
                renderSlot(_ctx.$slots, "footer")
              ], 512)) : createCommentVNode("", true)
            ])) : (openBlock(), createElementBlock(Fragment, { key: 2 }, [
              createElementVNode("div", _hoisted_3, [
                renderSlot(_ctx.$slots, "default")
              ]),
              hasFooterSlotContent.value ? (openBlock(), createElementBlock("footer", {
                key: 0,
                ref_key: "footer",
                ref: footer,
                class: "card__footer"
              }, [
                renderSlot(_ctx.$slots, "footer")
              ], 512)) : createCommentVNode("", true)
            ], 64))
          ]),
          _: 3
        }, 16)
      ], 16);
    };
  }
});

export { _sfc_main as default };
